const config = {
  rowSelection: true,
  listTitle: '场馆二维码',
  searchMode: "group",
  columns: [
    {
      title: "ID",
      dataIndex: "id",
      width: 150,
      ellipsis: true
    },
    {
      title: "排序",
      dataIndex: "sortNumber",
      width: 100
    },
    {
      title: "区域别名",
      dataIndex: "alias",
      width: 150,
      ellipsis: true
    },
    {
      title: "区域分类",
      dataIndex: "areaTypeDesc",
      width: 150,
      ellipsis: true
    },
    {
      title: "门店",
      dataIndex: "useCompanyList",
      render: 'useCompanyListFn',
      width: 150,
      ellipsis: true
    },
    {
      title: "讲解用时（分钟）",
      dataIndex: "explanTime",
      width: 150
    },
    {
      title: "区域描述",
      dataIndex: "name",
      width: 180,
      ellipsis: true
    },
    {
      title: "当期是否有活动",
      dataIndex: "currentActivity",
      render: "currentActivityFn",
      width: 150
    },
    {
      title: "二维码",
      dataIndex: "qrCode",
      render: "qrCodeFn",
      width: 150
    },
    {
      title: "更新人",
      dataIndex: "modifiedByName",
      width: 150
    },
    {
      title: "更新时间",
      dataIndex: "lastUpdatedTime",
      itemType: "dateTime",
      width: 180,
      ellipsis: true
    },
    {
      title: "操作",
      dataIndex: "actionTool",
      width: 260,
      render: "actionTool",
      fixed: "right"
    }
  ],
  search: [
    {
      name: "areaType",
      label: "区域分类",
      itemType: "select",
      data: "categoryList",
      showSearch: true,
      key: "priKey",
      labelKey: "name",
      optionFilterProp: "children",
      allowClear: true
    },
    {
      name: "busIds",
      label: "门店",
      itemType: "select",
      data: "companyList",
      mode: 'multiple',
      showSearch: true,
      key: "id",
      labelKey: "name",
      optionFilterProp: "children",
      allowClear: true
    },
  ],
  footer: [
    {
      label: "新增",
      type: "primary",
      events: ["onClick:onAdd"]
    },
    {
      label: "批量下载二维码",
      events: ["onClick:multiDownload"]
    }
  ]
}


export default config